// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"9208a840","551":"2a37cce4","828":"89358f49","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};